/* sp-pack-picker.js — packs con sello del kit Shopify maker (bloque sp_pack_picker, snippets/sp-pack-picker.liquid;
   CONTRACTS §K.3, PAR-127). Se carga con defer desde el snippet (no en la vista rápida). Idempotente (flag global) y con
   delegación en document, con listeners pasivos: sobrevive a los re-renders del editor de temas.
   Los radios de las tarjetas son los del tema (input[data-variant-input]): elegir una tarjeta la maneja theme.js
   (variante, disponibilidad, ?variant=). Este archivo sólo vuelve a dibujar lo que depende de las OTRAS opciones (p. ej.
   el color): la miniatura (foto de la variante; si no tiene, data-sp-pack-fallback), el precio, el sello y "por separado",
   con la misma cuenta que el Liquid y los precios reales del JSON de variantes del form ([data-variant-json]):
     sello        = precio de la tarjeta − precio del valor base (data-sp-pack-base) con las mismas otras opciones; > 0
     por separado = precio base + data-sp-pack-extra (precio del producto aparte que puso el Liquid); sólo si > precio
   Montos con theme.Currency.formatMoney(cents, theme.settings.moneyFormat) (M2: sin ceros finales). Sin theme.js no toca
   nada (queda lo que dibujó el Liquid). Escucha `change` en document (después del manejador del tema, que ya ajustó los
   radios a la variante disponible más cercana), `quickview:loaded`, `shopify:section:load` y `pageshow` (estado de los
   radios restaurado por el navegador). Marca cada raíz sincronizada con data-sp-pack-live. */
(function () {
  'use strict';
  if (window.__spPackPickerInit) return;
  window.__spPackPickerInit = true;

  var ROOT = '[data-sp-pack]';
  var WIDTHS = [72, 144, 216];

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function money(cents) {
    var t = window.theme;
    if (!t || !t.Currency || typeof t.Currency.formatMoney !== 'function') return null;
    return t.Currency.formatMoney(cents, t.settings && t.settings.moneyFormat);
  }

  /** URL de una imagen de Shopify con ?width=w (reemplaza el width que traiga). */
  function sized(url, w) {
    var u = String(url).replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; });
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function sectionOf(el) {
    return el.closest('[data-section-type="product"]') || el.closest('.product-section') || document;
  }

  function variantsOf(section) {
    var el = section.querySelector('[data-variant-json]');
    if (!el) return null;
    if (!el.__spPackVariants) {
      try { el.__spPackVariants = JSON.parse(el.textContent || el.value || 'null'); } catch (e) { return null; }
    }
    return Array.isArray(el.__spPackVariants) ? el.__spPackVariants : null;
  }

  /** Valores elegidos de la sección: { option1: 'Verde', option2: 'Sólo el detector' }. */
  function selection(section) {
    var sel = {};
    toArray(section.querySelectorAll('[data-variant-input]')).forEach(function (input) {
      var type = input.getAttribute('type');
      if ((type === 'radio' || type === 'checkbox') && !input.checked) return;
      if (input.dataset.index) sel[input.dataset.index] = input.value;
    });
    return sel;
  }

  /** Variante con `value` en la opción `key` y los demás valores elegidos (si no existe, la primera con ese valor). */
  function find(variants, key, value, sel) {
    var any = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v || v[key] !== value) continue;
      if (!any) any = v;
      var same = true;
      for (var k in sel) {
        if (Object.prototype.hasOwnProperty.call(sel, k) && k !== key && v[k] !== sel[k]) { same = false; break; }
      }
      if (same) return v;
    }
    return any;
  }

  function setThumb(root, item, variant) {
    var img = item.querySelector('img[data-sp-pack-thumb]');
    if (!img) return;
    var fi = variant.featured_image;
    var src = fi && fi.src ? fi.src : root.getAttribute('data-sp-pack-fallback');
    var id = String(fi && fi.id ? fi.id : root.getAttribute('data-sp-pack-fallback-id') || '');
    if (!src || id === img.getAttribute('data-sp-pack-img')) return;
    img.srcset = WIDTHS.map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ');
    img.src = sized(src, 144);
    img.setAttribute('data-sp-pack-img', id);
  }

  function sync(root) {
    if (!root || money(0) === null) return;
    var section = sectionOf(root);
    var variants = variantsOf(section);
    var key = root.getAttribute('data-sp-pack-option');
    if (!variants || !key) return;
    var sel = selection(section);
    var base = root.getAttribute('data-sp-pack-base');
    var bv = base !== null ? find(variants, key, base, sel) : null;
    toArray(root.querySelectorAll('[data-sp-pack-item]')).forEach(function (item) {
      var value = item.getAttribute('data-value');
      var v = find(variants, key, value, sel);
      if (!v) return;
      var price = item.querySelector('[data-sp-pack-price]');
      if (price) price.textContent = money(v.price);
      setThumb(root, item, v);

      var seal = item.querySelector('[data-sp-pack-seal]');
      if (seal) {
        var delta = bv && value !== base ? v.price - bv.price : 0;
        var a11y = item.querySelector('[data-sp-pack-seal-a11y]');
        var amount = seal.querySelector('[data-sp-pack-delta]');
        seal.hidden = !(delta > 0);
        if (a11y) a11y.hidden = !(delta > 0);
        if (delta > 0) {
          if (amount) amount.textContent = money(delta);
          if (a11y) a11y.textContent = String(a11y.getAttribute('data-sp-pack-tpl') || '').replace('[amount]', money(delta));
        }
      }

      var sep = item.querySelector('[data-sp-pack-sep]');
      if (sep) {
        var extra = Number(item.getAttribute('data-sp-pack-extra'));
        var sum = bv && value !== base && extra > 0 ? bv.price + extra : 0;
        sep.hidden = !(sum > v.price);
        var s = sep.querySelector('[data-sp-pack-sum]');
        if (s && sum > v.price) s.textContent = money(sum);
      }
    });
    root.setAttribute('data-sp-pack-live', '');
  }

  function syncIn(scope) {
    toArray((scope || document).querySelectorAll(ROOT)).forEach(sync);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || typeof t.matches !== 'function' || !t.matches('[data-variant-input]')) return;
    syncIn(sectionOf(t));
  }, { passive: true });
  document.addEventListener('quickview:loaded', function () { syncIn(document); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { syncIn(e.target); }, { passive: true });
  window.addEventListener('pageshow', function () { syncIn(document); }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncIn(document); }, { passive: true });
  else syncIn(document);
})();
